import { registerGtmDataLayer } from '../../../../../Features/Blocks/Video/gtmDataLayerService';

export default async function (body, url, formularInformation) {
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  })
      .then((res) => {
        if (res.ok) {
            const contentType = res.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                return res.json();
            } else {
                return res.text();
            }
      } else {
        throw new Error("Didn't work sending the calculation.")
      }
    })
    .then((json) => {
        return json
    })
    .catch((err) => {
      console.error(err)
      return err
    })

    if (response && response.name && response.email) {
        let dataLayer = {
            'event': 'track-immeo.calculation_send',
            'form_id': formularInformation.formId,
            'form_name': formularInformation.formName,
            'form_type': 'userdata',
            'userExistingClient': 'not_applicable',
            'eventCategory': 'calculation',
            'eventAction': 'submit',
            'eventLabel': formularInformation.formName,
            'payload': {
                'user_firstname': response.name,
                'user_lastname': response.lastname,
                'user_email': response.email,
                'user_phone': response.phonenumber
            }
        }
        registerGtmDataLayer(dataLayer);
    };

  return response
}
